import React from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import { FormType } from '../../views/forms/FormTypes';
import { JobWorkflowDefaultTaskType } from '../settings/jobs/JobTypeDefaultsTypes';

// Shows the read only default tasks of the job type of a contract job schedule
const ContractScheduleDefaultTaskRows: React.FC<{
    tasks: JobWorkflowDefaultTaskType[];
    forms: FormType[];
}> = ({
    tasks,
    forms,
}) => {
    const { t } = useTranslation();

    // Get the name of the form linked to a default task
    const getFormName = (task: JobWorkflowDefaultTaskType) => {
        const form = forms.find(form => form.id === task.form);
        return form ? form.name : null;
    };

    // Only show the non deleted default tasks
    const visibleTasks = tasks.filter(task => !task.deleted);
    if (visibleTasks.length === 0) return null;

    return (
        <div className='contract-schedule-default-tasks alert-warning'>
            <div className='contract-schedule-default-tasks-label'>
                {t('contract.job_schedule.default_tasks_label')}
            </div>
            {visibleTasks.map(task => (
                <div key={task.id ?? task.uuid} className='contract-schedule-task-row read-only'>
                    <span className='task-description-line'>
                        {task.description || getFormName(task)}
                        {task.required && (
                            <span className='task-required-icon active tooltip-icon'>
                                <FontAwesomeIcon icon={faLock} />
                                <span className="tooltip">{t('job.tasks.task_required_readonly_tooltip')}</span>
                            </span>
                        )}
                    </span>
                </div>
            ))}
        </div>
    );
};

export default ContractScheduleDefaultTaskRows;
